import { render, staticRenderFns } from "./UserTableTemplate.vue?vue&type=template&id=1b2aa18f&"
import script from "./UserTableTemplate.vue?vue&type=script&lang=js&"
export * from "./UserTableTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports